export default __webpack_public_path__ + "media/out.973f7b22.wav";